import React, { useState } from "react";
import DateInput from "../../../../components/DateInput";
import SelectInput from "../../../../components/SelectInput";
import SelectInput_2 from "../../../../components/SelectInput_2";
import MultiSelectInput from "../../../../components/MultiSelectInput";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";
import { BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useGetAllMasterLegalEntities } from "../hooks/useGetMasterLegalEntity";
import { useAgencyFromAgencyMapping } from "../hooks/useAgencyFromAgencyMapping";
import { useEmployees } from "../../Employees/Confie/hooks/useEmployees";
import usePolicyType from "../../../Utilities/ConfigureAgreement/PolicyType/hooks/usePolicyType";
import {
  agmtFilterParams,
  agmtFilterValues,
  filterConflictingAgreement,
  conflictingAgreementId,
} from "../atoms/atoms";
import { useEntity } from "../hooks/useEntity";
import { useStates } from "../../hooks/useStates";
import SelectHookFormMulti from "../../../../components/SelectHookFormMulti";
import { useGetAllCarriers } from "../../Carrier/hooks/useGetAllCarriers";
const TableFilters = ({
  mutateSearchAgreements,
  setConflictFilterParams,
  reset,
}) => {
  const [filteredValue, setFiltervalue] = useRecoilState(agmtFilterValues);
  const user = useRecoilValue(accountAtom);
  const [filterParams, setFilterParams] = useRecoilState(agmtFilterParams);
  const [, setConflictingAgreementIds] = useRecoilState(conflictingAgreementId);
  const [, setFilterConflictingAgreements] = useRecoilState(
    filterConflictingAgreement
  );

  const [allAgency, setAllAgency] = useState(false);
  const [allEntity, setAllEntity] = useState(false);
  const [allState, setAllState] = useState(false);
  const [allPolicy, setAllPolicy] = useState(false);
  const [previousSelected, setPreviousSelected] = useState([]);
  //DropDown Options
  const { data: carriers } = useGetAllCarriers();
  const carrieOptions = carriers
    ?.filter((x) => x.isActive === true)
    .map((x) => {
      return {
        label: x.carrierName,
        value: x.masterCarrierId,
      };
    });
  //for All option in States
  const allOption = {
    label: "ALL",
    value: "ALL",
  };

  const { data: masterLegalEntity, isLoading: masterLegalEntityLoading } =
    useGetAllMasterLegalEntities();
  const masterLegalEntityOpt = masterLegalEntity?.map((x) => {
    return {
      label: x.entityName,
      value: x.entityId,
    };
  });

  const { data: states } = useStates();
  const stateOptions = states?.map((x) => {
    return {
      label: x.state,
      value: x.state,
    };
  });
  const allstateOpts = stateOptions && [allOption, ...stateOptions];
  const { data: agencies } = useAgencyFromAgencyMapping();
  const agencyOptions = agencies
    ?.map((a) => {
      return {
        label: a.agencyName,
        value: a.agencyName,
      };
    })
    .filter(
      (row, index, self) =>
        self.findIndex((v) => v.label === row.label) === index
    );
  const allAgencyOpts = agencyOptions && [allOption, ...agencyOptions];
  const { data: entities } = useEntity();
  const entityOptions = entities
    ?.filter((x) => x.isActive === true)
    .map((ent) => {
      return {
        label: ent.entityName,
        value: ent.entityName,
        state: ent.stateCode,
      };
    })
    .filter(
      (row, index, self) =>
        self.findIndex((v) => v.label === row.label) === index
    );
  const allEntityOpts = entityOptions && [allOption, ...entityOptions];
  const { data: policies } = usePolicyType();
  const policyTypes = policies
    ?.filter((x) => x.isActive === true)
    .map((data) => {
      return { label: data.policyTypeName, value: data.policyTypeName };
    });

  const allPolicyOpts = policyTypes && [allOption, ...policyTypes];
  const { data: allEmployees } = useEmployees();
  const employees = allEmployees
    ?.filter(
      (x) =>
        x.status !== "Terminated" &&
        (user?.isFranchise && user?.isNonFranchise
          ? x.employeeId > 0
          : user?.isFranchise
          ? x.employeeTypeName === "Franchise"
          : x.employeeTypeName !== "Franchise")
    )
    .map((x) => {
      return {
        value: parseInt(x.employeeId),
        label: x.fullname + " - " + x.employeenumber,
      };
    });
  const paidTypeOptions = [
    { label: "As Earned", value: "As Earned" },
    { label: "As Written", value: "As Written" },
    { label: "As Collected", value: "As Collected" },
    { label: "Flat Rate", value: "Flat Rate" },
  ];
  const franchiseORConfie = [
    { label: "Confie", value: false },
    { label: "Franchise", value: true },
  ];
  const statusTypes = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
  ];
  const writingBusinessOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
  const billingTypes = [
    { value: "Agency", label: "Agency" },
    { value: "Direct", label: "Direct" },
    { value: "Direct / Agency", label: "Direct / Agency" },
  ];
  const handleSelection = (checkedValue, fieldName) => {
    if (checkedValue != null || (checkedValue && checkedValue.length > 0)) {
      if (fieldName === "Saleslead" || fieldName === "IsFranchise") {
        setFilterParams({
          ...filterParams,
          [fieldName]: checkedValue ? checkedValue.value : checkedValue,
        });
      } else if (fieldName === "Carrier") {
        const carrierIds = checkedValue.map((x) => x.value);

        setFilterParams({ ...filterParams, CarrierId: carrierIds });
      } else if (fieldName === "State") {
        const states = checkedValue.map((x) => x.value);

        setFilterParams({ ...filterParams, State: states });
      } else if (fieldName === "AgencyList") {
        const agencies = checkedValue.map((x) => x.value);

        setFilterParams({ ...filterParams, AgencyList: agencies });
      } else if (fieldName === "EntityList") {
        const entities = checkedValue.map((x) => x.value);

        setFilterParams({ ...filterParams, EntityList: entities });
      } else if (fieldName === "PolicyType") {
        setFilterParams({
          ...filterParams,
          [fieldName]: checkedValue ? checkedValue.label : "",
        });
      } else if (
        fieldName === "EffectiveDateFrom" ||
        fieldName === "EffectiveDateTo" ||
        fieldName === "ExpirationDate"
      ) {
        setFilterParams((params) => {
          return {
            ...params,
            [fieldName]: checkedValue ? checkedValue : null,
          };
        });
      } else {
        setFilterParams((params) => {
          return {
            ...params,
            [fieldName]: checkedValue ? checkedValue.value : null,
          };
        });
      }
    } else {
      setFilterParams(() => {
        const newFilter = Object.assign({}, filterParams);
        delete newFilter[fieldName];
        return newFilter;
      });
    }
    setFiltervalue((old) => {
      return { ...old, [fieldName]: checkedValue };
    });
  };
  const searchAgreement = () => {
    setFiltervalue({ ...filteredValue });
    mutateSearchAgreements(true);
  };

  const handleAllSelectChange = (
    selected,
    options,
    allOption,
    allActive,
    setAllActive,
    key,
    filterParams,
    setFilterParams,
    setFilterValue
  ) => {
    let updated = selected || [];

    // Selected ALL
    if (updated.some((x) => x.value === "ALL")) {
      if (
        updated.length === 1 ||
        updated.filter((x) => x.value !== "ALL").length ===
          previousSelected.length
      ) {
        // Only ALL → select every option
        updated = [allOption, ...options];
        setAllActive(true);
      } else {
        // ALL + others → treat as uncheck of ALL, remove ALL
        updated = updated.filter((x) => x.value !== "ALL");
        setAllActive(false);
      }
    }
    // Unchecked ALL (was active before but not in updated now)
    else if (allActive) {
      updated = [];
      setAllActive(false);
    }
    // Manual selection
    else {
      if (updated.length === options.length) {
        updated = [allOption, ...options];
        setAllActive(true);
      } else {
        setAllActive(false);
      }
    }

    // Save state
    setFilterParams({
      ...filterParams,
      [key]: updated.length ? updated.map((x) => x.value) : null,
    });

    setFilterValue((old) => ({
      ...old,
      [key]: updated.length ? updated : null,
    }));

    // Track previously selected (excluding ALL)
    setPreviousSelected(updated.filter((x) => x.value !== "ALL"));
  };

  return (
    <div className="pt-1 space-y-2">
      <div>
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full">
        <div className="mb-3">
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span className="whitespace-nowrap mr-4">
                    Agreement Details
                  </span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="bg-gray-100  p-3 sm:px-2 md:px-3">
                    <div className=" flex flex-col text-xs md:gap-x-4 gap-y-2">
                      {user.isFranchise && user.isNonFranchise && (
                        <div className="w-full">
                          <label className="block font-medium text-gray-700 mb-2">
                            Franchise/Confie
                          </label>
                          <SelectInput_2
                            options={franchiseORConfie}
                            value={filteredValue.IsFranchise}
                            onChange={(e) => {
                              handleSelection(e, "IsFranchise");
                            }}
                          />
                        </div>
                      )}
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Carrier
                        </label>
                        <MultiSelectInput
                          options={carrieOptions}
                          value={
                            filteredValue.Carrier ? filteredValue.Carrier : null
                          }
                          handleMultiSelect={(e) =>
                            handleSelection(e, "Carrier")
                          }
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          State
                        </label>
                        <SelectHookFormMulti
                          secondDiv="grid grid-cols-1"
                          options={allstateOpts}
                          value={filteredValue?.State}
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              stateOptions,
                              allOption,
                              allState,
                              setAllState,
                              "State",
                              filterParams,
                              setFilterParams,
                              setFiltervalue
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Agency
                        </label>
                        <SelectHookFormMulti
                          secondDiv="grid grid-cols-1"
                          options={allAgencyOpts}
                          value={filteredValue?.AgencyList}
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              agencyOptions,
                              allOption,
                              allAgency,
                              setAllAgency,
                              "AgencyList",
                              filterParams,
                              setFilterParams,
                              setFiltervalue
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Legal Entity
                        </label>
                        <SelectHookFormMulti
                          secondDiv="grid grid-cols-1"
                          options={allEntityOpts}
                          value={filteredValue?.EntityList}
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              entityOptions,
                              allOption,
                              allEntity,
                              setAllEntity,
                              "EntityList",
                              filterParams,
                              setFilterParams,
                              setFiltervalue
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Master Legal Entity
                        </label>
                        <SelectInput
                          options={masterLegalEntityOpt}
                          isLoading={masterLegalEntityLoading}
                          value={filteredValue?.masterLegalEntityId}
                          onChange={(e) =>
                            handleSelection(e, "masterLegalEntityId")
                          }
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Commission Paid As
                        </label>
                        <SelectInput_2
                          options={paidTypeOptions}
                          value={filteredValue.Commission}
                          onChange={(e) => {
                            handleSelection(e, "Commission");
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Policy Type
                        </label>

                        <SelectHookFormMulti
                          secondDiv="grid grid-cols-1"
                          options={allPolicyOpts}
                          value={filteredValue?.PolicyType} // PolicyType
                          onChange={(selected) => {
                            handleAllSelectChange(
                              selected,
                              policyTypes,
                              allOption,
                              allPolicy,
                              setAllPolicy,
                              "PolicyType",
                              filterParams,
                              setFilterParams,
                              setFiltervalue
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Effective Date From
                        </label>
                        <DateInput
                          className="w-full"
                          value={filteredValue.EffectiveDateFrom}
                          onChange={(e) => {
                            handleSelection(
                              e.target.value,
                              "EffectiveDateFrom"
                            );
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Effective Date To
                        </label>
                        <DateInput
                          className="w-full"
                          value={filteredValue.EffectiveDateTo}
                          onChange={(e) => {
                            handleSelection(e.target.value, "EffectiveDateTo");
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Expiration Date (Expired As Of)
                        </label>
                        <DateInput
                          className="w-full"
                          value={filteredValue.ExpirationDate}
                          onChange={(e) => {
                            handleSelection(e.target.value, "ExpirationDate");
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Agreement Status
                        </label>
                        <SelectInput_2
                          options={statusTypes}
                          value={filteredValue.AgreementIsActive}
                          onChange={(e) => {
                            handleSelection(e, "AgreementIsActive");
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Sales Leads
                        </label>
                        <SelectInput
                          options={employees}
                          value={filteredValue.SalesLead}
                          onChange={(e) => handleSelection(e, "SalesLead")}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Billing
                        </label>
                        <SelectInput_2
                          options={billingTypes}
                          value={filteredValue.Billing}
                          onChange={(e) => {
                            handleSelection(e, "Billing");
                          }}
                        />
                      </div>

                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Currently Writing New Business
                        </label>
                        <SelectInput_2
                          options={writingBusinessOptions}
                          value={filteredValue.isWritingNewBusiness}
                          onChange={(e) => {
                            handleSelection(e, "isWritingNewBusiness");
                          }}
                        />
                      </div>

                      <div className="flex justify-center items-end gap-x-2 mb-4 rounded-md mt-5">
                        <SearchButton
                          buttonValue="Search"
                          onClick={(e) => {
                            setFilterConflictingAgreements(false);
                            setConflictFilterParams();
                            setConflictingAgreementIds();
                            searchAgreement();
                          }}
                        />
                        <RefreshButton onClick={reset} />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
